import client from '@common/utils/rest';

export const getPedigrees = (params) => {
	return client({
    path: 'api/individuals/pedigrees',
    method: 'GET',
		params,
  }).then((response) => {
    return response.entity.data?.m_data;
  }); 
};